module.exports = __webpack_public_path__ + "static/media/MK 6 tmp.1893f327.mp3";